import { createContext, useContext, useState } from "react";

const ModuleControlsContext = createContext();

export function ModuleControlsProvider({ children }) {
  const [globalMetric, setGlobalMetric] = useState("O2"); // "O2" | "SO2" | "Temp"
  const [invertBombas, setInvertBombas] = useState(false);

  const toggleInvert = () => setInvertBombas((prev) => !prev);

  return (
    <ModuleControlsContext.Provider
      value={{ globalMetric, setGlobalMetric, invertBombas, toggleInvert }}
    >
      {children}
    </ModuleControlsContext.Provider>
  );
}

export function useModuleControls() {
  return useContext(ModuleControlsContext);
}
